/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react"
import { colors, fonts, weights, mediaQueries } from "./css-utils"
import { fontFaces } from "./fontFaces"

export const globalStyles = css`
  ${fontFaces};

  html {
    box-sizing: border-box;
    overflow-y: scroll;
    overscroll-behavior: none;
      scroll-behavior: smooth;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    font-size: 100%;
    background-color: ${colors.white};
    color-scheme: light;
    ${mediaQueries.xs} {
      font-size: 112.5%;
    }
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

    .gatsby-resp-image-figure {
        margin: 0 !important;
        padding: 0 !important;
    }

    .gatsby-resp-image-wrapper {
        margin: 0 auto !important;
        padding: 0 !important;
    }

    .gatsby-resp-image-image {
        margin: 0 !important;
    }

    .gatsby-resp-image-figcaption {
        font-family: ${fonts.sans};
        font-weight: ${weights.light};
        text-align: center;
        font-size: 14px;
        font-style: italic;
        margin-top: 0.5rem;
    }

  body {
    margin: 0;
    text-decoration: none;
    font-family: ${fonts.serif};
    font-weight: ${weights.regular};
    line-height: 1.45;
    word-wrap: break-word;
    font-kerning: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    font-feature-settings: "kern", "liga", "clig", "calt";
    color: ${colors.darkgray};
    transition: background-color 0.6s ease-in-out;

    > div {
      iframe {
        display: block;
        padding: 0;
        margin: 0 0 1.45rem;
      }
    }
    > #___gatsby {
      iframe {
        display: block;
        padding: 0;
        margin: 0 0 1.45rem;
      }
    }

    iframe {
      display: none;
      padding: 0;
      margin: 0;
    }
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }

  img,
  hgroup,
  dl,
  dd,
  p,
  figure,
  table,
  fieldset,
  noscript,
  address {
    padding: 0;
    margin: 0 0 1.45rem;
  }

  audio,
  canvas,
  progress,
  video {
    display: inline-block;
  }

  audio:not([controls]) {
    display: none;
    height: 0;
  }

  progress {
    vertical-align: baseline;
  }

  [hidden],
  template {
    display: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    padding: 0;
    margin: 0 0 1.45rem;
    font-family: ${fonts.serif};
    font-weight: ${weights.semibold};
    line-height: 1.1;
  }

  h1 {
    font-size: 2.25rem;
  }

  h2 {
    font-size: 1.62671rem;
  }

  h3 {
    font-size: 1.38316rem;
  }

  h4 {
    font-size: 1rem;
  }

  h5 {
    font-size: 0.85028rem;
  }

  h6 {
    font-size: 0.78405rem;
  }

  p {
    margin-bottom: 27px;
    font-family: ${fonts.sans};
    font-size: 16px;
    letter-spacing: 0.2;
    line-height: 1.7;

    ${mediaQueries.phoneLarge} {
      margin-bottom: 30px;
    }
  }

  p *:last-child {
    margin-bottom: 0;
  }

  a {
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
    text-decoration: none;
    color: ${colors.darkgrayFaded};
    transition: 0.3s ease all;
    pointer-events: all;

    &:hover,
    &:focus {
      outline-width: 0;
      color: ${colors.darkgray};
    }
  }

  b,
  strong,
  dt {
    font-weight: ${weights.bold};
  }

  dfn {
    font-style: italic;
  }

  mark {
    background-color: ${colors.yellow};
    color: ${colors.darkgray};
  }

  small {
    font-size: 80%;
  }

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  abbr,
  acronym,
  abbr[title] {
    border-bottom: 1px dotted ${colors.darkgrayFaded};
    cursor: help;
    text-decoration: none;
  }

  ul,
  ol {
    margin: 0 0 1.45rem;
    padding: 0 0 0 1rem;
    font-family: ${fonts.sans};
    font-size: 16px;
    list-style-position: outside;
    list-style-image: none;
  }

  ol li,
  ul li {
    margin-bottom: calc(1.45rem / 2);
  }

  li > ol {
    padding-left: 1.45rem;
    margin-bottom: calc(1.45rem / 2);
    margin-top: calc(1.45rem / 2);
  }

  li > ul {
    padding-left: 1.45rem;
    margin-bottom: calc(1.45rem / 2);
    margin-top: calc(1.45rem / 2);
  }

  li *:last-child {
    margin-bottom: 0;
  }

  li > p {
    margin-bottom: calc(1.45rem / 2);
  }

  blockquote {
    margin: 0 1.45rem 1.45rem;
    padding: 0;
  }

  blockquote *:last-child {
    margin-bottom: 0;
  }

  table {
    font-size: 1rem;
    line-height: 1.45rem;
    border-collapse: collapse;
    width: 100%;
  }

  thead {
    text-align: left;
  }

  th {
    font-weight: ${weights.bold};
  }

  td,
  th {
    text-align: left;
    border-bottom: 1px solid hsla(0, 0%, 0%, 0.12);
    font-feature-settings: "tnum";
    padding: 0.725rem 0.96667rem calc(0.725rem - 1px);

    &:first-of-type {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }

  td *:last-child,
  th *:last-child {
    margin-bottom: 0;
  }

  hr {
    box-sizing: content-box;
    margin: 0 0 calc(1.45rem - 1px);
    background: hsla(0, 0%, 0%, 0.2);
    border: none;
    height: 1px;
  }

  /*
   * Global Image Styles
   */

  svg:not(:root) {
    overflow: hidden;
  }

  figure {
    margin: 1em 40px;
  }

  img,
  picture {
    max-width: 100%;
    border-style: none;
  }

  /*
   * Global Form Styles
   */

  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0;
    font: inherit;
  }

  optgroup {
    font-weight: ${weights.bold};
  }

  button,
  input {
    overflow: visible;
  }

  button,
  select {
    text-transform: none;
  }

  [type="reset"],
  [type="submit"],
  button,
  html [type="button"] {
    -webkit-appearance: button;
  }

  [type="button"]::-moz-focus-inner,
  [type="reset"]::-moz-focus-inner,
  [type="submit"]::-moz-focus-inner,
  button::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  [type="button"]:-moz-focusring,
  [type="reset"]:-moz-focusring,
  [type="submit"]:-moz-focusring,
  button:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  fieldset {
    border: 1px solid silver;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
  }

  legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal;
  }

  textarea {
    overflow: auto;
  }

  [type="checkbox"],
  [type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }

  [type="number"]::-webkit-inner-spin-button,
  [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

  [type="search"] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }

  [type="search"]::-webkit-search-cancel-button,
  [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ::-webkit-input-placeholder {
    color: inherit;
    opacity: 0.54;
  }

  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }

  body:not(.user-is-tabbing) button:focus,
  body:not(.user-is-tabbing) input:focus,
  body:not(.user-is-tabbing) select:focus,
  body:not(.user-is-tabbing) textarea:focus,
  body:not(.user-is-tabbing) a:focus {
    outline: none;
  }

`
